import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // undefined = checking session, null = logged out, object = logged in
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    (async () => {
      try {
        const d = await api.get("/auth/me");
        setUser(d.user);
      } catch {
        setUser(null);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const d = await api.post("/auth/login", { email: email.trim(), password });
    setUser(d.user);
    return d.user;
  };

  const register = async (payload) => {
    const d = await api.post("/auth/register", payload);
    setUser(d.user);
    return d.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* clear locally regardless */
    }
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const d = await api.get("/auth/me");
      setUser(d.user);
    } catch (e) {
      /* keep current state */
    }
  };

  return (
    <AuthContext.Provider
      value={{ user, authReady: user !== undefined, login, register, logout, refreshUser }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
